import { useLayoutEffect } from 'react';

// Deferring to the next frame keeps the caller's layout change out of the observer callback,
// which browsers would otherwise report as a ResizeObserver loop.
export const useResizeOnNextFrame = (
  ref,
  onResize,
  { enabled = true, observeParent = false } = {}
) => {
  useLayoutEffect(() => {
    const element = ref.current;
    if (!enabled || !element || typeof ResizeObserver === 'undefined') return undefined;
    let frame = 0;
    const observer = new ResizeObserver(() => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => onResize());
    });
    observer.observe(element);
    if (observeParent && element.parentElement) observer.observe(element.parentElement);
    return () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
    };
  }, [ref, onResize, enabled, observeParent]);
};
